import React from 'react';
const CardPreLoader = ({ isLoading }) => {
  if (!isLoading) return null;

  return (
    <div className="card-loader-overlay">
      <div className="card-loader-content">       
        <div className="loader pop">
          {/* <div className="ring" aria-hidden="true"></div> */}
          <svg viewBox="0 0 200 200" role="img" aria-label="Loading">
            <rect className="back" x="24" y="56" width="120" height="120" rx="28" />
            <rect className="front" x="56" y="24" width="120" height="120" rx="28" />
            <g transform="translate(74,53)">
              <rect className="line" x="0" y="0" width="84" height="8" rx="4" />
              <rect className="line" x="14" y="18" width="70" height="8" rx="4" />
              <rect className="line" x="6" y="36" width="78" height="8" rx="4" />
              <rect className="line" x="16" y="54" width="68" height="8" rx="4" />
            </g>
          </svg>
        </div>
      </div>
    </div>
  );
};

export default CardPreLoader;

